import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BuilderRequest } from 'src/app/models/requests';
import { RequestBuilderHelper } from '../../../requestBuilderHelper';
import { DocumentActor } from 'src/app/models/actors';
import { DocumentModel } from 'src/app/models/document.model';

@Component({
  selector: 'app-reviewandsendactionslist',
  templateUrl: './reviewandsendactionslist.component.html'
})
export class ReviewandsendactionslistComponent implements OnInit {

  @Input('request') request!: BuilderRequest;
  @Output('emailTemplate') emailTemplate = new EventEmitter();
  actors: DocumentActor[] = [];
  documents: DocumentModel[] = [];
  actionIndex: number = 0;

  constructor(private requestBuilderHelper: RequestBuilderHelper) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    this.getActorsAndDocuments();
  }

  ngAfterViewChecked(): void {
    if (this.request && ((this.request.actors && this.request.actors.length > 0 && this.actors && this.actors.length === 0) ||  (this.request.documentInfo && this.request.documentInfo.length > 0 && this.documents && this.documents.length === 0))) {
      this.getActorsAndDocuments();
    }
  }

  getActorsAndDocuments(): void {
    this.sortActors();
    this.documents = this.request.documentInfo;
  }

  sortActors(): void {
    this.actors = this.request.actors?.sort((a,b) => a.order - b.order);
  }

  async openEmailPreview(event:Event) {
    this.emailTemplate.emit(event);
  }
  
  getLatestDeadline(index: number): Date | null{
    return this.requestBuilderHelper.getLatestDeadline(index, this.request);
  }

  isFirstActor(actor: DocumentActor) {
    return this.request.actors.indexOf(actor) === 0;
  }
}
